import { templating } from '../../../../library/dist/vanilla-libs/templateing';
import { getAllBuildSpecs, getBuildSpecs, getPaymentStatus, getTemplate, getUserByUserName, } from './content.service';
import './tailwind.css';
let specs = [];
let authenticatedUser = null;
let header;
const container = document.querySelector('#container');
const getCreatorUserName = () => {
    const path = window.location.pathname;
    const paths = path.split('/');
    return paths.length > 0 ? paths[paths.length - 1] : '';
};
const loadTemplate = async () => {
    const templateString = await getTemplate('buildspec-card');
    if (templateString) {
        const dom = new DOMParser().parseFromString(templateString, 'text/html');
        const template = dom.head.firstChild;
        if (!template) {
            return null;
        }
        return template;
    }
};
const loadHeader = async (templateFile) => {
    const templateString = await getTemplate(templateFile);
    if (templateString) {
        const dom = new DOMParser().parseFromString(templateString, 'text/html');
        const template = dom.head.firstChild;
        console.log('header template', template);
        if (!template) {
            return null;
        }
        return template;
    }
};
const template = await loadTemplate();
if (!template) {
    throw new Error('Template is missing');
}
const templateing = templating('container', template);
const renderHeader = async (type, header, creatorUser) => {
    if (!header) {
        throw new Error('Header template is missing');
    }
    const headerTemplateing = templating('t-header', header);
    switch (type) {
        case 'creator':
            headerTemplateing.bindObject('t-header', [
                {
                    className: 't-creator-header-image',
                    content: creatorUser?.headerImage ||
                        'https://storage.googleapis.com/hololink-cdn/assets/images/hologramd_header_crop.jpg',
                    attributeName: 'src',
                },
                {
                    className: 't-creator-profile-image',
                    content: creatorUser?.profileImage || '',
                    attributeName: 'src',
                },
                {
                    className: 't-creator-handle',
                    content: creatorUser?.userName
                        ? `@${creatorUser?.userName}`
                        : '@[unknown]',
                },
                {
                    className: 't-creator-screen-name',
                    content: creatorUser?.screenName ?? '[unknown]',
                },
                {
                    className: 't-profile-text',
                    content: creatorUser?.profileText ?? '[no profile text]',
                },
            ]);
            break;
        case 'list':
            await headerTemplateing.bindObject('t-header', [
                {
                    className: 't-list-header-image',
                    content: 'https://storage.googleapis.com/hololink-cdn/assets/images/hologramd_header_crop.jpg',
                },
                { className: 't-list-header-text', content: 'Hologramd' },
            ]);
            break;
        default:
            throw new Error(`Unknown header type: ${type}`);
    }
};
const renderSpec = async (spec, user) => {
    let isPaid = false;
    if (user) {
        console.log('authenticatedUser', user);
        const paymentStatus = await getPaymentStatus(spec._id, user.tokenParsed.sub);
        console.log('paymentStatus', paymentStatus);
        isPaid = paymentStatus?.status === 'completed';
        console.log('isPaid', isPaid);
    }
    console.log('render spec', spec);
    templateing.bindObject('buildspec-card', [
        {
            className: 't-thumbnail-url',
            content: spec.status.status === 'Paid'
                ? isPaid
                    ? spec.thumbnailPublicUrl ||
                        'https://storage.googleapis.com/hololink-cdn/assets/images/hologramd-placeholder.png'
                    : spec.thumbnailUrl?.signedUrl ||
                        'https://storage.googleapis.com/hololink-cdn/assets/images/hologramd-placeholder.png'
                : spec.thumbnailUrl?.signedUrl ||
                    'https://storage.googleapis.com/hololink-cdn/assets/images/hologramd-placeholder.png',
            attributeName: 'src',
        },
        {
            className: 't-profile-image',
            content: spec.creator?.profileImage ? spec.creator?.profileImage : '',
            attributeName: 'src',
        },
        {
            className: 't-screen-name',
            content: spec.creator?.screenName ?? '[unknown]',
        },
        {
            className: 't-handle',
            content: spec.creator?.userName
                ? `@${spec.creator?.userName}`
                : '@[unknown]',
        },
        {
            className: 't-payment',
            content: spec.status.status === 'Paid' && spec.price
                ? `${spec.price.amount} ${spec.price.currency}`
                : '',
        },
        {
            className: 't-watch-btn',
            content: spec.status.status === 'Paid' && spec.price
                ? isPaid
                    ? `UNLOCKED: Watch Now`
                    : `Unlock ${spec.price.currency} ${spec.price.amount}`
                : 'View at home',
        },
        {
            className: 't-watch-btn',
            attributeName: 'data-buildspec-id',
            content: spec._id,
        },
        {
            className: 't-creator',
            attributeName: 'data-creator-id',
            content: spec.creator?.userName || '',
        },
        {
            className: 't-description',
            content: spec.description,
        },
    ]);
};
const renderAllSpecs = (specs, user) => {
    if (!container) {
        return;
    }
    if (container.innerHTML) {
        container.innerHTML = '';
    }
    console.log('renderAllSpecs', specs, user);
    specs.forEach(async (spec) => {
        await renderSpec(spec, user);
    });
};
/// TODO: see if a user is loggedIn
document.addEventListener('authenticated', async (e) => {
    const detail = e.detail;
    /// We're authenticated get stuff from the auth folder
    console.log(detail);
    authenticatedUser = detail;
    console.log('authenticated user', detail);
    renderAllSpecs(specs, detail);
});
// sort specs by id alfanumeric string
console.log('specs.length', specs.length);
specs.sort((a, b) => {
    if (a._id < b._id) {
        console.log(a._id, 'is less than', b._id);
        return 0;
    }
    return -1;
});
if (!container) {
    console.error('Container not found');
}
else {
    container.addEventListener('click', async (event) => {
        const target = event.target;
        if (target && target instanceof Element) {
            switch (true) {
                case target.matches('.t-watch-btn'):
                    const specId = target.getAttribute('data-buildspec-id');
                    if (specId) {
                        console.log('Opening buildspec', specId);
                        const req = `${process.env.CONTENT_API}/build/${specId}`;
                        console.log('requesting build details from', req);
                        console.log('Redirect to payment');
                        // try to fetch from content API and log eny errors
                        window
                            .open(`${process.env.CONTENT_API}/build/${specId}`, '_blank')
                            ?.focus();
                    }
                    break;
                case Boolean(target.closest('.t-creator')):
                    console.log('Creator clicked', target);
                    const creator = target.closest('.t-creator');
                    if (!creator) {
                        console.error('Creator not found');
                        return;
                    }
                    else {
                        const creatorUserName = creator.getAttribute('data-creator-id');
                        console.log('creatorId', creatorUserName);
                        if (creatorUserName) {
                            console.log('Opening user profile', creatorUserName);
                            window.open(`/${creatorUserName}`, '_self');
                        }
                    }
                    break;
                case Boolean(target.closest('.t-description')):
                    console.log('Description clicked', target);
                    const description = target.closest('.t-description');
                    if (!description) {
                        console.error('Description not found');
                        return;
                    }
                    description.classList.toggle('truncate');
                    description.classList.toggle('w-60');
                    description.classList.toggle('whitespace-normal');
                    break;
                default:
                    // Her kan du evt. finde ud af, hvilket spec der er tale om via data-attributter
                    console.log('BuildSpec card was clicked', target);
            }
        }
    });
}
// Initial fetching
(async () => {
    // Get data independent of authentication
    const creatorUserName = getCreatorUserName();
    let creatorUser = null;
    if (creatorUserName) {
        creatorUser = await getUserByUserName(creatorUserName);
        specs = await getBuildSpecs(creatorUser?.keycloakId || '');
        header = await loadHeader('creator-header');
        renderHeader('creator', header, creatorUser);
    }
    else {
        specs = await getAllBuildSpecs();
        header = await loadHeader('list-header');
        renderHeader('list', header, creatorUser);
    }
    console.log('initial header', header);
    console.log('initial creatorUser', creatorUser);
    console.log('initial specs', specs);
    // Initial spec card rendering uden autentificering
    console.log('Rendering specs');
    // Initial spec card rendering uden autentificering
    renderAllSpecs(specs, authenticatedUser);
})();
